module.exports = __webpack_public_path__ + "img/image-map-revercode-593664a0.png";